module.exports = __webpack_public_path__ + "img/FA3.69bb6ba1.png";